import React from 'react';
import classnames from 'classnames';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import PropTypes from 'prop-types';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import { lighten } from '@material-ui/core/styles/colorManipulator';
import Tooltip from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Tooltip';

const styles = theme => ({
  root: {
    borderLeft: '3px solid',
    borderLeftColor: 'transparent',
    '&:hover': {
      color: theme.palette.facet.primaryBlue,
    },
    '&:hover $icon': {
      color: theme.palette.facet.primaryBlue,
    },
  },
  icon: {
    color: theme.palette.facet.primaryGray3,
    width: theme.spacing(2.2),
  },
  listItemIconRoot: {
    minWidth: theme.spacing(2.5),
    width: theme.spacing(4.5),
  },
  divider: {
    borderBottom: '1px solid',
    borderBottomColor: lighten(theme.palette.grey[300], 0.10),
  },
  secondaryText: {
    color: theme.palette.common.white,
  },
  secondaryTextMobile: {
    color: theme.palette.facet.primaryBlue,
  },
});

const OnClickItem = ({
  className,
  classes,
  icon,
  label,
  isMobileItem,
  onClick,
  test,
  secondaryText,
  isSubLink,
  PrimaryTypographyProps,
  tooltip,
  hideDivider,
}) => {
  const Icon = icon;

  const listItemText = (
    <ListItemText
      primary={label}
      primaryTypographyProps={{
        variant: isMobileItem ? 'h2' : 'h6',
        noWrap: true,
        ...PrimaryTypographyProps,
      }}
      secondary={secondaryText}
      secondaryTypographyProps={{
        className: classnames({
          [classes.secondaryText]: !isMobileItem,
          [classes.secondaryTextMobile]: isMobileItem,
        }),
        variant: isMobileItem && !isSubLink ? 'h2' : 'h6',
        noWrap: true,
      }}
    />
  );

  return (
    <ListItem
      button
      test={test}
      onClick={() => onClick()}
      className={classnames(className, {
        [classes.root]: !isMobileItem,
        [classes.divider]: !hideDivider && !isMobileItem,
        [classes.mobileLinkItem]: isMobileItem,
      })}
    >
      {!isMobileItem && Icon && (
      <Tooltip title={label}>
        <ListItemIcon
          classes={{
            root: classes.listItemIconRoot,
          }}
        >
          <Icon className={classes.icon} />
        </ListItemIcon>
      </Tooltip>
      )}
      {
        tooltip ? <Tooltip title={tooltip}>{listItemText}</Tooltip>
          : listItemText
      }
    </ListItem>
  );
};

OnClickItem.defaultProps = {
  className: '',
  isMobileItem: false,
  onClick: null,
  test: '',
  icon: null,
  secondaryText: null,
  isSubLink: false,
  PrimaryTypographyProps: null,
  tooltip: null,
  hideDivider: false,
};

OnClickItem.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  icon: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.object,
  ]),
  label: PropTypes.string.isRequired,
  isMobileItem: PropTypes.bool,
  onClick: PropTypes.func,
  test: PropTypes.string,
  secondaryText: PropTypes.string,
  isSubLink: PropTypes.bool,
  PrimaryTypographyProps: PropTypes.object,
  tooltip: PropTypes.string,
  hideDivider: PropTypes.bool,
};

export default withStyles(styles)(OnClickItem);
